import type { Category } from "@/constants/categories";

type IndianGroceryProduct = {
  id: string;
  name: string;
  categorySlug: Category["slug"];
  brand: string;
  price: number;
  unit: string;
  image: string;
};

const IMG = {
  groceries:
    "https://images.unsplash.com/photo-1615897570582-285ffe259530?crop=entropy&cs=srgb&fm=jpg&q=85",
};

const item = (
  id: string,
  name: string,
  brand: string,
  unit: string,
  price: number,
): IndianGroceryProduct => ({
  id,
  name,
  categorySlug: "indian-groceries",
  brand,
  unit,
  price,
  image: IMG.groceries,
});

export const INDIAN_GROCERY_PRODUCTS: IndianGroceryProduct[] = [
  // Shan / Sana Cup spice mixes & pastes (page 1)
  item("ig-sana-chilli-flakes", "Sana Cup Chilli Flakes", "Sana", "100g", 3.49),
  item("ig-shan-dal-hot-ready", "Shan Dal Hot (Ready to Eat)", "Shan", "300g", 4.99),
  item("ig-sana-dal-makhani-ready", "Sana Cup Dal Makhani (Ready to Eat)", "Sana", "300g", 4.99),
  item("ig-shan-paneer-tikka-ready", "Shan Paneer Tikka (Ready to Eat)", "Shan", "300g", 4.99),
  item("ig-sana-instant-shred-chutney", "Sana Cup Instant Shredded Chutney", "Sana", "200g", 3.99),
  item("ig-shan-instant-aloo-mix", "Shan Instant Aloo Mix", "Shan", "100g", 3.49),
  item("ig-sana-instant-biryani", "Sana Cup Instant Biryani", "Sana", "200g", 4.49),
  item("ig-shan-instant-haleem", "Shan Instant Haleem Mix", "Shan", "300g", 5.49),
  item("ig-sana-instant-millet-khichdi", "Sana Cup Instant Millet Khichdi", "Sana", "200g", 4.29),
  item("ig-shan-instant-millet-upma", "Shan Instant Millet Upma Mix", "Shan", "200g", 4.29),
  item("ig-sana-pav-bhaji-ready", "Sana Cup Pav Bhaji (Ready to Eat)", "Sana", "300g", 4.99),
  item("ig-shan-kofta-mutton-curry", "Shan Kofta Mutton Curry", "Shan", "50g", 2.99),
  item("ig-sana-oregano-herb", "Sana Cup Oregano Herb", "Sana", "50g", 2.49),
  item("ig-shan-oregano-seasoning", "Shan Oregano Seasoning", "Shan", "50g", 2.49),
  item("ig-sana-paneer-butter-masala", "Sana Cup Paneer Butter Masala (Ready to Eat)", "Sana", "300g", 4.99),
  item("ig-shan-sambar-mix", "Shan Sambar Mix", "Shan", "100g", 3.49),
  item("ig-sana-support-chutney", "Sana Cup Support Chutney", "Sana", "200g", 3.99),
  item("ig-shan-tandoori-chatpat", "Shan Tandoori Chatpat", "Shan", "50g", 2.99),
  item("ig-sana-bombay-veg", "Sana Cup Bombay Veg (Ready to Eat)", "Sana", "300g", 4.99),
  item("ig-shan-veg-biryani-gravy", "Shan Veg Biryani Gravy (Ready to Eat)", "Shan", "300g", 4.99),
  item("ig-sana-rice-mix-tomato", "Sana Cup Rice Mix (Ready Tomato)", "Sana", "200g", 3.99),

  // Ready meals & mixes (page 2)
  item("ig-haldiram-aloo-bhujia", "Haldiram's Aloo Bhujia", "Haldiram's", "200g", 5.99),
  item("ig-haldiram-chana-dal", "Haldiram's Chana Dal", "Haldiram's", "200g", 5.49),
  item("ig-haldiram-moong-dal", "Haldiram's Moong Dal", "Haldiram's", "200g", 5.49),
  item("ig-haldiram-mixture", "Haldiram's Mixture", "Haldiram's", "200g", 5.99),
  item("ig-mtr-biryani-paste", "MTR Biryani Paste", "MTR", "200g", 4.99),
  item("ig-mtr-sambar-powder", "MTR Sambar Powder", "MTR", "100g", 3.49),
  item("ig-mtr-rasam-powder", "MTR Rasam Powder", "MTR", "100g", 3.49),

  // Chapati / Roti / Paratha
  item("ig-chapati-plain", "Chapati Plain", "Kawan", "20 pcs", 6.99),
  item("ig-paratha-plain", "Paratha Plain", "Kawan", "5 pcs", 4.99),
  item("ig-roti-whole-wheat", "Roti Whole Wheat", "Kawan", "20 pcs", 7.49),

  // Vermicelli / Noodles
  item("ig-vermicelli-roasted", "Vermicelli Roasted", "Bambino", "200g", 2.49),
  item("ig-sevai-plain", "Sevai Plain", "Bambino", "200g", 2.49),
  item("ig-maggi-noodles-4pk", "Maggi Noodles", "Maggi", "4 pack", 4.99),

  // Lentils / Pulses
  item("ig-toor-dal-1kg", "Toor Dal", "Patanjali", "1kg", 6.99),
  item("ig-moong-dal-1kg", "Moong Dal", "Patanjali", "1kg", 7.49),
  item("ig-chana-dal-1kg", "Chana Dal", "Patanjali", "1kg", 5.99),
  item("ig-masoor-dal-1kg", "Masoor Dal", "Patanjali", "1kg", 6.49),
  item("ig-urad-dal-1kg", "Urad Dal", "Patanjali", "1kg", 7.99),

  // Rice & Flour
  item("ig-basmati-rice-5kg", "Basmati Rice", "Daawat", "5kg", 19.99),
  item("ig-atta-5kg", "Whole Wheat Atta", "Aashirvaad", "5kg", 12.99),
  item("ig-rice-flour-1kg", "Rice Flour", "Eastern", "1kg", 4.49),
  item("ig-besan-1kg", "Besan (Gram Flour)", "Rajdhani", "1kg", 4.99),

  // Spices
  item("ig-turmeric-powder-200g", "Turmeric Powder", "MDH", "200g", 3.99),
  item("ig-red-chilli-powder-200g", "Red Chilli Powder", "MDH", "200g", 3.99),
  item("ig-coriander-powder-200g", "Coriander Powder", "MDH", "200g", 3.49),
  item("ig-cumin-powder-200g", "Cumin Powder", "MDH", "200g", 4.29),
  item("ig-garam-masala-100g", "Garam Masala", "MDH", "100g", 3.99),
  item("ig-biryani-masala-50g", "Biryani Masala", "Shan", "50g", 2.99),
  item("ig-tandoori-masala-50g", "Tandoori Masala", "Shan", "50g", 2.99),

  // Papad & snacks
  item("ig-papad-udad-200g", "Papad Udad", "Lijjat", "200g", 3.99),
  item("ig-papad-masala-200g", "Papad Masala", "Lijjat", "200g", 3.99),
];
